import { Avatar, Card, Col, Row, Table, Tag } from "antd";
import React from "react";


const getTagHomeScoreColor = (record) => {
    const homeGoals = record?.homeGoals;
    const awayGoals = record?.awayGoals;

    if (homeGoals > awayGoals) return 'green';
    if (homeGoals < awayGoals) return 'magenta';

    return 'blue';
}

const getTagAwayScoreColor = (record) => {
    const homeGoals = record?.homeGoals;
    const awayGoals = record?.awayGoals;

    if (awayGoals > homeGoals) return 'green';
    if (awayGoals < homeGoals) return 'magenta';

    return 'blue';
}


const LatestApplications = ({ items, isLoading, errorMessage }) => {

    const tableColumns = [{
        title: 'Fixture',
        dataIndex: 'fixture',
        align: 'left',
        width: 350,
        render: (_, record) => (
            <>
                <Row gutter={24} align='middle'>
                    <Col xl={2} lg={2} md={4} sm={4} xs={4} className="text-center p-0 m-0">
                        <Avatar
                            size={25}
                            style={{ padding: '2px', border: '1px solid' }}
                            src={record?.fixture?.home?.logo}
                        />
                    </Col>
                    <Col xl={18} lg={18} md={16} sm={16} xs={16} className="text-left">
                        {record?.fixture?.home?.name}
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={4} className="text-left">
                        <Tag color={getTagHomeScoreColor(record)} style={{ width: '30px', visibility: record?.fixture?.shortStatus === 'NS' && 'hidden' }} className="m-0 text-center font-weight-bold">{record?.fixture?.homeGoals}</Tag>
                    </Col>
                </Row>
                <Row gutter={24} align='middle'>
                    <Col xl={2} lg={2} md={4} sm={4} xs={4} className="text-center p-0 m-0">
                        <Avatar
                            size={25}
                            style={{ padding: '2px', border: '1px solid' }}
                            src={record?.fixture?.away?.logo}
                        />
                    </Col>
                    <Col xl={18} lg={18} md={16} sm={16} xs={16} className="text-left">
                        {record?.fixture?.away?.name}
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={4} className="text-left">
                        <Tag color={getTagAwayScoreColor(record)} style={{ width: '30px', visibility: record?.fixture?.shortStatus === 'NS' && 'hidden' }} className="m-0 text-center font-weight-bold">{record?.fixture?.awayGoals}</Tag>
                    </Col>
                </Row>
            </>
        )
    },
    {
        title: 'Market',
        dataIndex: 'market',
        align: 'left',
        width: 100,
        render: (_, record) => record?.market?.code
    },
    {
        title: 'Best value',
        dataIndex: 'bestValue',
        align: 'left',
        width: 120,
        render: (_, record) => `${record?.bestValue} (${parseFloat(record?.confidence * 100).toFixed(2)}%)`
    },
    {
        title: 'Stake',
        dataIndex: 'stake',
        align: 'center',
        width: 100,
        render: (_, record) => record?.stake
    },
    {
        title: 'Expected win',
        dataIndex: 'expectedWin',
        align: 'center',
        width: 120,
        render: (_, record) => record?.expectedWin
    },
    {
        title: 'Status',
        align: 'center',
        width: 50,
        render: (_, record) => <Tag color={record?.status?.color} className="m-0 font-weight-bold">{record?.status?.name}</Tag>
    },
    ];


    return (
        <Card title="Recent predictions" style={{ minHeight: "354px" }}>
            <Card style={{ borderRadius: "0", marginBottom: '8px' }} styles={{ body: { padding: "0" } }}>
                <div className="table-responsive">
                    <Table
                        rowKey="id"
                        size="small"
                        columns={tableColumns}
                        dataSource={items}
                        pagination={false}
                        showHeader={true}
                        loading={isLoading}
                        scroll={{ x: 'max-content' }}
                    />
                </div>
            </Card>
        </Card>
    );
};

export default LatestApplications;